import { Horse, User } from "@/openapi";
import { _ } from "@/pages/_app";
import { IStore } from "@/redux/store";
import { Locales, getLocale, setLocale } from "@/utils/translation";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Image from "next/image";
import Link from "next/link";
import { useRouter } from "next/router";
import { useState } from "react";
import { connect } from "react-redux";
import DropdownButton from "./buttons/DropdownButton";
import HorseDayLogo from "@/components/icons/HorseDayLogo";
import LanguageIcon from "@/components/icons/LanguageIcon";
import ChevronIconSecondary from "@/components/icons/ChevronIconSecondary";

interface ICheckoutNavbarProps {
  user: User | undefined;
  onLangChange: () => void;
}

function localeToReadable(locale: Locales) {
  const localeMap = {
    'en_GB': 'EN',
    'de': 'DE',
    'is': 'IS'
  };

  return localeMap[locale] || 'Unknown';
}

const CheckoutNavbar = (props: ICheckoutNavbarProps) => {
  const router = useRouter();

  const [locale, _setLocale] = useState(getLocale());
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);

  const renderUserImage = () => {
    const userImage = props.user?.aThumbnail;
    if (!userImage) {
      return (
        <AccountCircleIcon
          style={{ height: 32, width: 32, color: "gray", border: "none" }}
        />
      );
    }
    return (
      <Image
        className="w-8 h-8 rounded-full"
        alt="user photo"
        src={userImage!}
        width={32}
        height={32}
      />
    );
  };

  return (
    <nav
      className="flex justify-center py-7 sm:py-10 w-full flex relative z-[110] rounded-tl-[2rem] rounded-tr-[2rem] bg-white lg:rounded-tl-[3.2rem] lg:rounded-tr-[3.2rem]"
    >
      <div className="flex justify-between items-center max-w-[1360px] px-5 w-full lg:px-10">
        <div className="flex-row flex">
          <Link href="https://www.horseday.com/" className="flex items-center w-[7.5rem] sm:w-[10rem]" rel="noopener noreferrer">
            <HorseDayLogo />
          </Link>

        </div>
        <div className="flex flex-row ">
          <DropdownButton<Locales>
            className="text-sm cursor-pointer rounded-full ml-1 "
            title={""}
            items={[
              { title: "EN", value: "en_GB" },
              { title: "DE", value: "de" },
              { title: "IS", value: "is" },
            ]}
            selected={locale}
            onChange={async (v) => {
              _setLocale(v);
              await setLocale(v);
              props.onLangChange();
              setIsDropdownOpen(false);
            }}
            // onToggle={(open) => setIsDropdownOpen(open)}
            onToggle={(open) => {
              setIsDropdownOpen(open);
            }}
            child={
              <div className="flex items-center text-[#68431c] text-base rounded-lg border pr-2 sm:p-2 sm:pl-3 sm:pr-3 border-[unset] border-0 sm:mr-[0.5rem] mr-[0rem] cursor-pointer">
                <LanguageIcon className="w-[24px] sm:w-[31px] h-[24px] sm:h-[31px]" />
                <ChevronIconSecondary
                  className={`w-[24px] sm:w-[31px] h-[24px] sm:h-[31px] transition-transform duration-200 ${isDropdownOpen ? 'rotate-180' : ''}`}
                />
                {/* {localeToReadable(locale)} */}
              </div>
            }
          />

          <button type="button" className="text-sm  rounded-full ">
            {props.user ? (
              <Link href="/settings">{renderUserImage()}</Link>
            ) : (
              <Link
                href="/login"
                className="text-[#6C4B28] font-semibold text-[0.9rem] sm:text-[1rem] border-2 px-[0.8rem] py-[0.4rem] sm:px-[1.4rem] sm:py-[0.7rem] border-[#6C4B28] cursor-pointer bg-gradient-to-b from-[rgba(218,131,41,0.05)] to-[rgba(218,131,41,0.1)] rounded-full"
              >
                {_("Sign up")}
              </Link>
            )}
          </button>
        </div>
      </div>
    </nav>
  );
};

const mapStateToProps = (state: IStore) => {
  const { user } = state.userState || undefined;

  return { user };
};

export default connect(mapStateToProps)(CheckoutNavbar);
